import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'react-bootstrap';
import { FaMapMarkerAlt, FaBoxes, FaCalendarAlt, FaTruckLoading, FaDollarSign, FaShieldAlt, FaRedoAlt, FaGlobe, FaUserShield, FaStar } from 'react-icons/fa';

export default function FAQs() {
  return (
    <div
      className="p-4 text-white"
      style={{
        backgroundImage: `url('/Jazuz-moving-truck.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        minHeight: '100vh',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="bg-dark bg-opacity-75 p-4 rounded">
        <h2 className="mb-4 text-white">Frequently Asked Questions</h2>
        <Accordion defaultActiveKey="0">
          <AccordionItem eventKey="0">
            <AccordionHeader><FaMapMarkerAlt className="me-2 text-primary" />1. What areas do you currently operate in?</AccordionHeader>
            <AccordionBody>
              We currently operate in <strong>Lagos, Nigeria</strong>, and in <strong>Winnipeg and Saskatoon, Canada</strong>. You can always contact us to confirm availability in nearby cities.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="1">
            <AccordionHeader><FaBoxes className="me-2 text-primary" />2. What types of moves do you handle?</AccordionHeader>
            <AccordionBody>
              We handle <strong>residential</strong>, <strong>office</strong>, <strong>store</strong>, and <strong>custom moves</strong>. Whether it’s a small apartment or a large commercial space, Jazuz has you covered.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="2">
            <AccordionHeader><FaCalendarAlt className="me-2 text-primary" />3. How far in advance should I book a move?</AccordionHeader>
            <AccordionBody>
              We recommend booking at least <strong>5–7 days in advance</strong>. However, we can accommodate last-minute moves depending on availability.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="3">
            <AccordionHeader><FaTruckLoading className="me-2 text-primary" />4. Do you offer packing and unpacking services?</AccordionHeader>
            <AccordionBody>
              Yes! Our team can help you <strong>pack, unpack, disassemble, and reassemble</strong> your items as part of a seamless moving experience.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="4">
            <AccordionHeader><FaDollarSign className="me-2 text-primary" />5. How do you calculate the cost of a move?</AccordionHeader>
            <AccordionBody>
              Pricing is based on <strong>distance, volume of items, type of move</strong>, and any <strong>additional services</strong> requested. Get an instant quote on our homepage or contact us directly.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="5">
            <AccordionHeader><FaShieldAlt className="me-2 text-primary" />6. Are my items insured during the move?</AccordionHeader>
            <AccordionBody>
              Yes. All moves come with <strong>basic insurance coverage</strong>, and we also offer <strong>comprehensive coverage options</strong> for high-value items.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="6">
            <AccordionHeader><FaRedoAlt className="me-2 text-primary" />7. Can I reschedule or cancel my booking?</AccordionHeader>
            <AccordionBody>
              Absolutely. You can reschedule or cancel up to <strong>24 hours before your move</strong> without a penalty. Cancellations after that may incur a fee.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="7">
            <AccordionHeader><FaGlobe className="me-2 text-primary" />8. What if I need help moving outside your listed locations?</AccordionHeader>
            <AccordionBody>
              We may still be able to help! Please contact our support team, and we’ll try to accommodate or refer you to a trusted partner.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="8">
            <AccordionHeader><FaUserShield className="me-2 text-primary" />9. How are your movers trained?</AccordionHeader>
            <AccordionBody>
              Our movers are <strong>professionally trained</strong>, background-checked, and regularly assessed to ensure top-notch service delivery.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem eventKey="9">
            <AccordionHeader><FaStar className="me-2 text-primary" />10. Why should I choose Jazuz over traditional movers or doing it myself?</AccordionHeader>
            <AccordionBody>
              We bring <strong>North American professionalism</strong>, <strong>efficient scheduling</strong>, <strong>crew welfare</strong>, and a <strong>customer-first mindset</strong> into every move—making your experience stress-free and reliable.
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
}
